import adminCss from './sass/adminpage.module.scss'
import themeCss from '../components/sass/theme.module.scss'

import { isAuctionOwner } from './permissionsutil'

import AuctionEdit from './AuctionEdit'
import AuctionDeleteButton from './AuctionDeleteButton'

export default function AdminAuctionDetail(props) {

  if (!props.auction) return <> </>
  
  return (
    <div>
      <h3 className={adminCss['admin-auction-page-tab-header']}>
        Auction Details
      </h3>

      <AuctionEdit auction={props.auction} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} 
        unsavedAuction={props.unsavedAuction} setUnsavedAuction={props.setUnsavedAuction} />

      {props.auction.Status === 'PREVIEW' && (isAuctionOwner(props.auction) || localStorage.isAuctionSuperAdmin) &&
        <AuctionDeleteButton history={props.history} auction={props.auction} location={'bottom'} />}

      {props.auction.Status !== 'PREVIEW' && localStorage.isAuctionSuperAdmin && process.env.REACT_APP_AWS_ENVIRONMENT !== 'prod' &&
        <AuctionDeleteButton history={props.history} auction={props.auction} location={'bottom'} />}

      <button className={`${themeCss['FilledWhite']} ${themeCss['button']} ${themeCss['centered-button']}`}
        onClick={() => props.setGoToIndex(1)}>
          Go To Items</button>
    </div>
  )
}